<h2>Send Feedback</h2>

<form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()" class="grid">
  <section class="grid grid-flow-row gap-4">
    <label>Feedback Type</label>
          <div class="grid grid-flow-col gap-2">
      <label>
        <input type="radio" formControlName="type" value="comments" />
        Comments
      </label>
      <label>
        <input type="radio" formControlName="type" value="suggestions" />
        Suggestions
      </label>
      <label>
        <input type="radio" formControlName="type" value="questions" />
        Questions
      </label>
    </div>

    <div>
      <label for="feedback">Feedback</label>
      <textarea id="feedback" formControlName="feedback"></textarea>
    </div>

    <div>
      <label for="firstName">First Name</label>
      <input id="firstName" autocomplete="given-name" formControlName="firstName" />
    </div>

    <div>
      <label for="lastName">Last Name</label>
      <input id="lastName" autocomplete="family-name" formControlName="lastName" />
    </div>

    <div>
      <label for="email">Email</label>
      <input id="email" autocomplete="email" formControlName="email" />
    </div>
  </section>
</form>

    <div class="grid gap-4 grid-flow-col justify-end">
  <button type="button" class="button button--black-outline" (click)="onCancel()">
    Cancel
  </button>
  <button type="button" class="button button--blue" [disabled]="!feedbackForm.valid" (click)="onSubmit()">
    Submit
  </button>
</div>
